module.exports = __webpack_public_path__ + "img/deposit-instructions-2.d68165a5.png";